'use client'

import { Modal, type ModalProps } from '../modal.tsx'
import { fullPageModalVariants } from '../utils.ts'
import { FullPageModalBody } from './full-page-modal-body.tsx'
import { FullPageModalDescription } from './full-page-modal-description.tsx'
import { FullPageModalFooter } from './full-page-modal-footer.tsx'
import { FullPageModalImage } from './full-page-modal-image.tsx'
import { FullPageModalSubtitle } from './full-page-modal-subtitle.tsx'
import { FullPageModalTitle } from './full-page-modal-title.tsx'

import { motion } from 'motion/react'

const FullPageModalComponent = ({ children, ...rest }: ModalProps) => {
  return (
    <Modal {...rest}>
      <motion.div
        className="max-w-md"
        initial={fullPageModalVariants.initial}
        animate={fullPageModalVariants.open}
        exit={fullPageModalVariants.initial}
      >
        {children}
      </motion.div>
    </Modal>
  )
}

const FullPageModalNamespace = Object.assign(FullPageModalComponent, {
  Body: FullPageModalBody,
  Title: FullPageModalTitle,
  Subtitle: FullPageModalSubtitle,
  Description: FullPageModalDescription,
  Image: FullPageModalImage,
  Footer: FullPageModalFooter,
})

export { FullPageModalNamespace as FullPageModal }
